module.exports = __webpack_public_path__ + "img/Czechia.27b9e1e9.png";